import { HTTP, rootApi, SuccessResponse } from '../index';
import { GetInvoicesResponse, GetPaymentMethodsResponse } from './types';

export const paymentMethodApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentMethods: builder.query<GetPaymentMethodsResponse, void>({
      query: () => {
        return {
          url: `/payment_methods`,
          method: HTTP.GET,
        };
      },
      providesTags: ['PaymentMethods'],
    }),

    addPaymentMethod: builder.mutation<GetPaymentMethodsResponse, {payment_method: string}>({
      query: (body) => {
        return {
          url: `/payment_methods`,
          method: HTTP.POST,
          body,
        };
      },
      invalidatesTags: ['PaymentMethods'],
    }),

    setDefaultPaymentMethod: builder.mutation<GetPaymentMethodsResponse, {payment_method: string}>({
      query: ({ payment_method }) => {
        return {
          url: `/payment_methods/${payment_method}/set_default_payment_method`,
          method: HTTP.POST
        };
      },
      invalidatesTags: ['PaymentMethods'],
    }),

    repayOpenInvoice: builder.mutation<SuccessResponse, void>({
      query: () => {
        return {
          url: `/payment_methods/repay_open_invoice`,
          method: HTTP.POST
        };
      },
      invalidatesTags: ['Me'],
    }),

    getInvoices: builder.query<GetInvoicesResponse, void>({
      query: () => {
        return {
          url: `/payment_methods/invoices`,
          method: HTTP.GET,
        };
      },
    }),

    deletePaymentMethod: builder.mutation<SuccessResponse, {payment_method: string}>({
      query: ({ payment_method }) => {
        return {
          url: `/payment_methods/${payment_method}`,
          method: HTTP.DELETE,
        };
      },
      invalidatesTags: ['PaymentMethods'],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPaymentMethodsQuery,
  useAddPaymentMethodMutation,
  useSetDefaultPaymentMethodMutation,
  useGetInvoicesQuery,
  useRepayOpenInvoiceMutation,
  useDeletePaymentMethodMutation
} = paymentMethodApi;
